import { render, staticRenderFns } from "./UserAccountPopup.vue?vue&type=template&id=49bda241&scoped=true&"
import script from "./UserAccountPopup.vue?vue&type=script&lang=js&"
export * from "./UserAccountPopup.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountPopup.vue?vue&type=style&index=0&id=49bda241&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bda241",
  null
  
)

export default component.exports